/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { getPropApi } from '../../config/api/Endpoints';
import {
  ApiCredentialsType,
  ApiEndPointsNames,
  HttpVerbType,
  InitApiType,
} from '../../types';
import { Bundle } from '../../util';
import AxiosHelper from './AxiosHelper';
import HandlePromise from './HandlePromise';

const execApi = (
  method: HttpVerbType,
  apiDomain: ApiEndPointsNames,
  path: string,
  credentialsType: ApiCredentialsType,
  init: InitApiType,
): Promise<any> => {
  const config = Bundle.getValue('config');
  if (config.debug) {
    // eslint-disable-next-line no-console
    console.debug(`Api.ts => execApi: ${method}`);
  }

  const { apiType, endpoint } = getPropApi(
    config.service.environment,
    apiDomain,
  );
  const isMock = config.service.environment === 'MOCK';
  return HandlePromise(
    AxiosHelper[method](apiDomain, path, credentialsType, init),
    apiType,
    isMock,
    endpoint,
  );
};

export const get = (
  apiDomain: ApiEndPointsNames,
  path: string,
  credentialsType: ApiCredentialsType,
  init: InitApiType,
): Promise<any> => execApi('get', apiDomain, path, credentialsType, init);

export const post = (
  apiDomain: ApiEndPointsNames,
  path: string,
  credentialsType: ApiCredentialsType,
  init: InitApiType,
): Promise<any> => execApi('post', apiDomain, path, credentialsType, init);

export const put = (
  apiDomain: ApiEndPointsNames,
  path: string,
  credentialsType: ApiCredentialsType,
  init: InitApiType,
): Promise<any> => execApi('put', apiDomain, path, credentialsType, init);

export const deleteop = (
  apiDomain: ApiEndPointsNames,
  path: string,
  credentialsType: ApiCredentialsType,
  init: InitApiType,
): Promise<any> => execApi('delete', apiDomain, path, credentialsType, init);

export const patch = (
  apiDomain: ApiEndPointsNames,
  path: string,
  credentialsType: ApiCredentialsType,
  init: InitApiType,
): Promise<any> => execApi('patch', apiDomain, path, credentialsType, init);
